export const formatNumberOfEpisodes = (numberOfEpisodes: number) =>
  numberOfEpisodes === 1 ? '1 Episode' : `${String(numberOfEpisodes)} Episodes`;
